/*! proton-checkout-direct.js — route every checkout entry straight to
 * /checkout?skip_shop_pay=true.
 *
 * WHY (proven 2026-08-05, Diego approved the fix 2026-09-10): a bare /checkout
 * (and the native cart-form POST that redirects to it) 302s THROUGH shop.app —
 * Shopify's "universal redirect". Any shopper with an ad-blocker, privacy
 * extension, Pi-hole/NextDNS or corporate DNS gets Chrome's "shop.app is
 * blocked" dead end and CANNOT BUY. skip_shop_pay=true is the only thing that
 * removes the hop; Shop Pay remains fully available INSIDE checkout — this
 * only skips the blockable interstitial.
 *
 * Coexists with proton-upsell.js's checkout intercept: that handler runs on
 * click (capture) and preventDefaults before any submit fires; its own
 * navigation (go()) already carries the param. This script only catches the
 * paths that reach a real form submit or a plain /checkout link.
 */
(function () {
  "use strict";
  var DEST = "/checkout?skip_shop_pay=true";

  // 1) Native cart-form submissions via a checkout button (cart page, cart
  //    drawer, sticky bar's programmatic click). Cart contents live in the
  //    session cookie, so a direct GET to /checkout is equivalent to the POST.
  document.addEventListener(
    "submit",
    function (e) {
      try {
        var f = e.target;
        if (!f || f.nodeName !== "FORM") return;
        var action = f.getAttribute("action") || "";
        if (!/\/cart\/?(\?|$)/.test(action)) return;
        var s = e.submitter || document.activeElement;
        if (!s || (s.getAttribute && s.getAttribute("name")) !== "checkout") return;
        e.preventDefault();
        window.location.assign(DEST);
      } catch (err) { /* fall through to native behaviour */ }
    },
    true
  );

  // 2) Plain anchors pointing at /checkout.
  document.addEventListener(
    "click",
    function (e) {
      try {
        var a = e.target.closest && e.target.closest('a[href="/checkout"], a[href^="/checkout?"]');
        if (!a) return;
        var href = a.getAttribute("href");
        if (href.indexOf("skip_shop_pay") !== -1) return;
        e.preventDefault();
        window.location.assign(href + (href.indexOf("?") === -1 ? "?" : "&") + "skip_shop_pay=true");
      } catch (err) { /* fall through */ }
    },
    true
  );
})();
